import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";

import { Profile } from "./profile";
import { Page } from "./page";
import { Email } from "./email";

export const infrastructureRoutes: Array<RouteObject> = [
  {
    path: "/profile",
    element: <Protected />,
    children: [
      { index: true, element: <Profile /> },
      { path: "/profile/:tab", element: <Profile /> },
    ],
  },
  {
    path: "/pages",
    element: <Protected />,
    children: [
      { index: true, element: <Page /> },
      { path: "/pages/:id", element: <Page /> },
    ],
  },
  {
    path: "/emails",
    element: <Protected />,
    children: [{ index: true, element: <Email /> }],
  },
];
